import { render, staticRenderFns } from "./SettingIndexView.vue?vue&type=template&id=77de134a&scoped=true"
import script from "./SettingIndexView.vue?vue&type=script&lang=js"
export * from "./SettingIndexView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77de134a",
  null
  
)

export default component.exports